import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './permissionForm';
import List from './permissionList';

const settings = {
    pathRegister: paths.permissionRegister,
    pathList: paths.permission,
    apiPath: 'permission',
    permissionAdmin: null,
    title: 'Permissões',
};

const Permission: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={{ ...settings, title: 'Permissão' }} />
        </MainContainer>
    );
};

const PermissionList: React.FC = () => {
    return (
        <MainContainer>
            <List settings={settings} />
        </MainContainer>
    );
};

export { Permission, PermissionList };
